module.exports = __webpack_public_path__ + "static/media/snowy-3.b6eea2cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/snowy-3.svg
// module id = 528
// module chunks = 0